import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { Image, Transformation } from 'cloudinary-react';
import { useCurrentWidth } from '@fff-web/fff-ui-shared/hooks';
import { useUserContext } from '@fff-web/fff-utilities';
import { WB_TITLE, WB_SUBTITLE } from './welcomeBackTestIds';
import ReactivateButton from './ReactivateButton';
import HeroProducts from './HeroProducts';
import breakpoints from '../../../utils/breakpoints';

import styles from './WelcomeBack.module.scss';

const DESKTOP_WIDTH = 1440;
const MOBILE_WIDTH = 375;
const DESKTOP_HEIGHT = 830;
const MOBILE_HEIGHT = 618;

const WelcomeBack = () => {
  const currentWidth = useCurrentWidth();
  const [isReactivateBtnInView, setIsReactivateBtnInView] = useState(false);
  const { userInfo } = useUserContext();
  const isDesktop = currentWidth >= breakpoints.medium;
  const publicId = isDesktop ? 'prod/reactivate/hero/fffwk-bg_3x' : 'prod/reactivate/hero/hero-bg-m_3x';
  const width = isDesktop ? DESKTOP_WIDTH : MOBILE_WIDTH;
  const height = isDesktop ? DESKTOP_HEIGHT : MOBILE_HEIGHT;
  const buttonStyles = isDesktop ? { position: 'absolute', top: 260 } : { position: 'absolute', bottom: 93 };

  const buildReactivationButton = () => {
    if (isDesktop || userInfo.loggedIn) {
      return <ReactivateButton styles={buttonStyles} />;
    }
    if (!isReactivateBtnInView) {
      buttonStyles.position = 'fixed';
    }
    return (
      <InView onChange={(inView) => setIsReactivateBtnInView(inView)} className={styles.btnWrapper}>
        <ReactivateButton styles={buttonStyles} />
      </InView>
    );
  };

  return (
    <section style={{ width, height }} className={styles.wbSection} data-testid="welcomeBack">
      <h1
        data-testid={WB_TITLE}
        className={styles.title}
      >
        WELCOME BACK
      </h1>
      <h2
        data-testid={WB_SUBTITLE}
        className={styles.subtitle}
      >
        Discover Your Favorite Things, Again
      </h2>
      <div className={styles.imageWrapper}>
        <Image
          cloudName="fabfitfun"
          secure="true"
          width={width}
          height={height}
          publicId={publicId}
          loading="lazy"
          alt=""
        >
          <Transformation
            width={width}
            height={height}
            dpr="2.0"
            crop="scale"
          />
          <Transformation fetchFormat="auto" />
          <Transformation quality="auto" />
        </Image>
      </div>
      <HeroProducts />
      {buildReactivationButton()}
    </section>
  );
};

export default WelcomeBack;
